import React from 'react';
import './PageHero.css';

// Shared hero for inner pages.
const PageHero = ({ eyebrow, title, subtitle, children, align = 'left' }) => (
  <section className={`page-hero page-hero-${align}`}>
    <div className="grid-bg" aria-hidden="true" />
    <div className="glow page-hero-glow" aria-hidden="true" />
    <div className="container page-hero-inner">
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h1 className="page-hero-title">{title}</h1>
      {subtitle && <p className="page-hero-subtitle">{subtitle}</p>}
      {children}
    </div>
  </section>
);

export default PageHero;
